const pieChart = (data) => {
    var valores = [];
    var nome = [];
    var soma = 0
    data.forEach((el) => {
    soma += el.valor;
    valores.push(el.valor);
    nome.push(el.nome);
    });
    return {
        series: [ ...valores ],
        chartOptions: {
          customScale: 0.5,
          labels: [...nome], 
          colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c", "#343a40", "#74788d", "#e84118", "#9c88ff"],
          legend: {
            show: true,
            position: 'bottom',
            floating: false,
            fontSize: '14px',
          },
          responsive: [{
              breakpoint: 600,
              options: {
                  chart: {
                      height: 240
                  },
                  legend: {
                      show: false
                  },
              }
          }],
          tooltip: {
            y: { 
              formatter: function (y) {
                if (typeof y !== "undefined") {
                  return y.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) + "  |  " + ((y/soma)*100).toFixed(1) + "%";
                  
                }
                return y;
              },
              
            }
          },
        }
      }
};

const radialChart = (data) => 
{
  var atribuiCor = '#556ee6'
  if((100 - data) >= 80){
    atribuiCor = '#f46a6a'
  }
  if((100 - data) <= 25){
    atribuiCor = '#34c38f'
  }
  return {
    series: [(100 - data).toFixed(2)],
    chartOptions: {
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
          }
        },
        stroke: {
          dashArray: 4
        },
        labels: ['Consumo'],
        colors: [atribuiCor],
    }
  };
};

const barChart = {
  series: [{
      data: [8617525915, 2689092961, 1816359704, 963916075, 780393355, 492179220, 368971861, 392599299, 282579720, 632779676]
  }],
  chartOptions: {
      chart: {
          toolbar: {
              show: false,
          }
      },
      plotOptions: {
          bar: {
              horizontal: true,
          }
      },
      dataLabels: {
          enabled: false
      },
      colors: ['#556ee6'],
      grid: {
          borderColor: '#f1f1f1',
      },
      xaxis: {
          categories: ['Combustíveis', 'Alimentação', 'Hospedagem', 'Quilometragem', 'Materiais de Trabalho', 'Manut. Conserv. De Veículos', 'Comunicação - Telefonia E internet', 'Pedágio', 'Correios', 'Outros'],
      },
      tooltip: {
        y: { 
          formatter: function (y) {
            if (typeof y !== "undefined") {
              return "R$"+y + " | " + ((y)*100).toFixed(1) + "%";
              
            }
            return y;
          },
        }
      },
  }
};
export { pieChart, radialChart, barChart };